import React, {useEffect, useState} from 'react';
import {List} from '@material-ui/core';
import {NavLink} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import IntlMessages from "../../util/IntlMessages";
import DialogCloseExit from '../../util/DialogCloseExit';
import DialogClose from '../../util/DialogClose';
import DialogClose3 from '../../util/DialogClose3';
import {userSignOut} from "../../actions";
import {getprofile, logout} from "../../api/api";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import share from "../../assets/images/share.png";
import more from "../../assets/images/more.png";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";


let deferredPrompt;
const NavMenuItem = props => {
    const {name, icon, link, check, check3} = props;
    const dispatch = useDispatch();
    const [dialogclose, setDialogclose] = React.useState(false);
    const [dialogclose3, setDialogclose3] = React.useState(false);
    const [loader, setLoader] = useState(false);
    const [loader3, setLoader3] = useState(false);
    const [iosmodal, setIosmodal] = useState(false)


    useEffect(() => {

        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevent the mini-infobar from appearing on mobile
            // alert('asd');
            e.preventDefault();
            // Stash the event so it can be triggered later.
            deferredPrompt = e;

            // Update UI notify the user they can install the PWA
            // showInstallPromotion();

            // Optionally, send analytics event that PWA install promo was shown.
            console.log(`'beforeinstallprompt' event was fired.`);
        });


    }, []);


    const firedandroidinstalled = async () => {
        // deferredPrompt.prompt();
        // // Wait for the user to respond to the prompt
        // const {outcome} = await deferredPrompt.userChoice;
        // // Optionally, send analytics event with outcome of user choice
        // console.log(`User response to the install prompt: ${outcome}`);
        // // We've used the prompt, and can't use it again, throw it away
        // deferredPrompt = null;
        // alert('1');

        if (!deferredPrompt) {
            return;
        }
        // alert('2');
        const result = await deferredPrompt.prompt();
        // console.log(`Install prompt was: ${result.outcome}`);
        // disableInAppInstallPrompt();


    };






    const onc = (e) => {
        e.preventDefault();
        if (check3) {
            setDialogclose3(true);
        } else {
            setDialogclose(true);
        }
    };

    const onClickyes = () => {
        setLoader(true);

        logout()
            .then((response) => {
                if (response.data.errorCode === 0) {
                    // setLoader(false);
                    // dispatch(userSignOut());
                    // debugger;
                    localStorage.setItem('user_id', '');
                    dispatch(userSignOut());
                    window.location.reload();
                }
            })
            .catch((error) => {
            });

    }

    const onClickcancel = () => {
        setDialogclose(false);
    }


    const onClickyes3 = () => {
        setDialogclose3(false);
        // firedandroidinstalled();
        openInNewTab('https://cafebazaar.ir/app/com.hamyarmizban')
    }
    const openInNewTab = url => {
        // alert('ai')
        //  const newWindow  = window.open(url, '_self', 'noopener noreferrer');
        //  if(newWindow) newWindow.opener = null

        window.open(url, '_blank', 'noopener,noreferrer');
        //myFunction(url);
    };

    const onClickcancel3 = () => {
        setDialogclose3(false);
        setIosmodal(true);
    }

    const onContactClose = () => {
        setIosmodal(false);
    };

    const onCloseDialog3 = () => {
        setDialogclose3(false);
        setDialogclose(false);
    };



    return (
        <List component="div" className='nav-menu-item'>
            {check ?
                <NavLink onClick={(e) => onc(e)} className="prepend-icon nav-menu-link" to={link}>
                    {!!icon && (
                        <i className={'zmdi zmdi-hc-fw  zmdi-' + icon}/>
                    )}
                    <span className="nav-text" style={{fontWeight: 'bold'}}><IntlMessages id={name}/></span>
                </NavLink>

                :
                <NavLink className="prepend-icon nav-menu-link" to={link}>
                    {!!icon && (
                        <i className={'zmdi zmdi-hc-fw  zmdi-' + icon}/>
                    )}
                    <span className="nav-text" style={{fontWeight: 'bold'}}><IntlMessages id={name}/></span>
                </NavLink>

            }
            <DialogClose open={dialogclose} title='خروج' body='آیا مایل به خروج از سامانه هستید؟' loader={loader}
                         yes={onClickyes} cancel={onClickcancel} close={onCloseDialog3}/>

            <DialogClose3 open={dialogclose3} title='نصب اپلیکیشن' body='اپلیکیشن همیار میزبان را نصب کنید'
                          loader={loader3}
                          yes={onClickyes3} cancel={onClickcancel3} close={onCloseDialog3}/>


            <Dialog open={iosmodal} PaperProps={{
                style: {margin: 0}
            }} onClose={onContactClose} className="slideInUpTiny">
                {/*<DialogTitle>*/}
                {/*<div style={{fontFamily: 'iransans'}}>*/}
                {/*ثبت مخاطب جدید*/}
                {/*</div>*/}

                {/*</DialogTitle>*/}

                <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', width: '100%'
                }}>

                    <div style={{margin: 10, fontSize: 15, fontFamily: 'iransans'}}>
                        نصب نسخه وب اپلیکیشن
                    </div>

                    <IconButton onClick={onContactClose} aria-label="Close">
                        <CloseIcon/>
                    </IconButton>


                </div>


                <DialogContent>
                    <div style={{
                        display: 'flex', justifyContent: 'start', flex: 1,
                        alignItems: 'start', flexDirection: 'column', width: 270,
                    }}>


                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: 15,
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img src={share} style={{width: 25, height: 25}}></img>
                            <div style={{
                                fontFamily: 'iransans',
                                marginRight: 5,
                                fontWeight: 'bold',
                                fontSize: 13
                            }}>۱.در نوار پایین دکمه Share را بزنید.
                            </div>

                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: 15,
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img src={more} style={{width: 25, height: 25}}></img>
                            <div style={{
                                fontFamily: 'iransans',
                                marginRight: 5,
                                fontWeight: 'bold',
                                fontSize: 13
                            }}>۲.دکمه Add to Home Screen را انتخاب کنید.
                            </div>

                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: 15,
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <div style={{fontWeight: 'bold', fontSize: 14}}>Add</div>
                            <div style={{
                                fontFamily: 'iransans',
                                marginRight: 5,
                                fontWeight: 'bold',
                                fontSize: 13
                            }}>۳.در مرحله اخر روی دکمه Add بزنید.
                            </div>

                        </div>


                        <div className="d-flex align-items-center" style={{width: '100%'}}>

                            <Button onClick={onContactClose} disabled={loader} variant="contained"

                                    style={{
                                        width: '100%',
                                        height: 40,
                                        backgroundColor: '#3f51b5',
                                        marginTop: 15,
                                        marginBottom: 15,
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        border: '1px solid ',
                                    }}
                                    className="iran-font">
                                <div style={{fontSize: 15, color: '#fff', fontWeight: 500}}>متوجه شدم</div>

                            </Button>


                        </div>


                    </div>


                </DialogContent>


            </Dialog>


        </List>
    )
};

export default NavMenuItem;